import React from 'react';
import './Footer.scss';
import logo from '../../../img/nekrodruk-logo-dark.png';

import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook'; // <- import ikony

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className='footer'>
            <div className='footer_txt'>
                <div className="footer_columns">
                    <div className="footer_links">
                        <a href="/Polityka_prywatnosci_nekrodruk.pdf" target="_blank" rel="noopener noreferrer">Polityka prywatności</a>
                        <a href="/Regulamin_nekrodruk.pdf" target="_blank" rel="noopener noreferrer">Regulamin</a>
                        <a href="/demo">DEMO</a>

                        <a href="mailto:nekrodruk@gmail.com" className="footer_contact">
                            <EmailIcon fontSize="small" />
                            nekrodruk@gmail.com
                        </a>

                        {/* Link do Facebooka */}
                        <a
                            href="https://www.facebook.com/profile.php?id=61579782703147"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer_contact"
                        >
                            <FacebookIcon fontSize="small" />
                            Facebook
                        </a>
                    </div>
                    <img className="footer_logo" src={logo} alt="Nekrodruk logo" />
                </div>
                <p className='footer_p2'>© {currentYear} Nekrodruk. Wszelkie prawa zastrzeżone.</p>
            </div>
        </footer>
    );
}
